
export enum ControlEffectivenessEnum {
  NotEffective = 0,
  Effective = 1,
  PartiallyEffective = 2
}

export function getControlEffectivenessLabel(value: number | string): string {
  switch (+value) {
    case ControlEffectivenessEnum.NotEffective:
      return 'Not Effective';
    case ControlEffectivenessEnum.Effective:
      return 'Effective';
    case ControlEffectivenessEnum.PartiallyEffective:
      return 'Partially Effective';
    default:
      return value.toString();
  }
}